export const all = <T extends any>(arr: T[], pred: (item: T) => boolean): boolean =>
    arr.reduce<boolean>((result, item) => result && pred(item), true);

